import { __extends } from "tslib";
import { Event } from './Event';
var ActivityEvent = /** @class */ (function (_super) {
    __extends(ActivityEvent, _super);
    function ActivityEvent(type, bubbles, cancelable, activating) {
        if (bubbles === void 0) { bubbles = false; }
        if (cancelable === void 0) { cancelable = false; }
        if (activating === void 0) { activating = false; }
        var _this = _super.call(this, type, bubbles, cancelable) || this;
        _this.activating = !!activating;
        return _this;
    }
    ActivityEvent.classInitializer = null;
    ActivityEvent.classSymbols = null;
    ActivityEvent.instanceSymbols = null;
    // JS -> AS Bindings
    ActivityEvent.ACTIVITY = 'activity';
    return ActivityEvent;
}(Event));
export { ActivityEvent };
